export default "__VITE_ASSET__Dkc6PS6m__"